  import { Message } from '../node_modules/element-ui/lib/index'
import promise from '../node_modules/es6-promise/lib/es6-promise'
promise.polyfill()
import Cookie from './cookie.js'
import axios from '../node_modules/axios/index'
import utils from './index.js'
const baseUrl =
  process.env.NODE_ENV === 'production' ? '' : window.baseConfig.baseUrl
/**
 * token的名字
 */
const TOKEN_KEY = 'token'
// 创建axios实例
var instance = axios.create({
  timeout: 1000 * 30,
})
// 设置post请求头
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded; charset=utf-8'

const queryObj = utils.getRequest()
if (queryObj.token) {
  sessionStorage.setItem(TOKEN_KEY, queryObj.token)
  instance.defaults.headers.Authorization = queryObj.token
}
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = Cookie.getToken() || sessionStorage.getItem(TOKEN_KEY)
    config.url = baseUrl + config.url
    return config
  },
  (error) => Promise.error(error)
)

// 响应拦截器
instance.interceptors.response.use(
  (res) => {
    if (
      res.data == null &&
      res.config.responseType === 'json' &&
      res.request.responseText != null
    ) {
      try {
        // eslint-disable-next-line no-param-reassign
        res.data = JSON.parse(res.request.responseText)
      } catch (e) {
        // ignored
      }
    }
    if (res.data.success == false) {
      if (res.data.errorStr == '未知错误') {
        return { success: true, data: null }
      } else if (res.data.errorCode == 4001) {
        Message({
          message: res.data.errorStr,
          type: 'error',
          duration: 2000,
        })
        Cookie.removeCookie(TOKEN_KEY)
        window.location.replace(
          window.location.protocol +
            '//' +
            window.location.host +
            '/login?overdue=1&code=' + res.data.errorCode + '&msg=' + res.data.errorStr
        )
        return
      }
      Message({
        message: res.data.errorStr,
        type: 'error',
        showClose: true,
        duration: 2000,
      })
      return res.data
    } else {
      if (res.data.errorCode == 401) {
        return res.data
      } else if (res.data.errorCode == 4001) {
        Cookie.removeCookie(TOKEN_KEY)
        window.location.replace(
          window.location.protocol +
            '//' +
            window.location.host +
            '/login?overdue=1&code=' + res.data.errorCode + '&msg=' + res.data.errorStr
        )
      }
      return res.data
    }
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '错误请求'
          break
        case 401:
          err.message = '未授权，请重新登录'
          Cookie.removeCookie(TOKEN_KEY)
          window.location.replace(
            window.location.protocol +
              '//' +
              window.location.host +
              '/login?overdue=1&code=' + res.data.errorCode + '&msg=' + res.data.errorStr
          )
          break
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = '请求错误,未找到该资源'
          break
        case 405:
          err.message = '请求方法未允许'
          break
        case 408:
          err.message = '请求超时'
          break
        case 500:
          err.message = '服务器端出错'
          break
        case 501:
          err.message = '网络未实现'
          break
        case 502:
          err.message = '网络错误'
          break
        case 503:
          err.message = '服务不可用'
          break
        case 504:
          err.message = '网络超时'
          break
        case 505:
          err.message = 'http版本不支持该请求'
          break
        default:
          err.message = `连接错误${err.response.status}`
      }
    } else {
      err.message = '连接到服务器失败'
    }
    Message({
      message: err.message,
      type: 'error',
      showClose: true,
      duration: 2000,
    })
    return Promise.resolve({})
  }
)
export default instance
